import { useState, useEffect } from "react";
import { useUser } from "../../../contexts/userContext/userContext.js";
import apiRequest from "../../../utils/ApiRequest/apiRequest.js";
import PageExampleSection from "./FormMarketingSections/PageExample.js";
import MainBanner from "./FormMarketingSections/MainBanner.js";
import CustomFormSection from "./FormMarketingSections/CustomFormSection.js";
import FormFeaturesSection from "./FormMarketingSections/FormFeaturesSection.js";
import EmbedQuestions from "./FormMarketingSections/EmbedQuestions.js";
import InboxSection from "./FormMarketingSections/InboxSection.tsx";

import "./FormMarketingPageNew.scss";

const FormsMarketingPage = () => {
  const { getUserData } = useUser();
  const userData = getUserData();
  const [numOfForms, setNumOfForms] = useState(0);

  const getNumOfEmbedForms = async () => {
    const response = await apiRequest("Users", "GetNumOfEmbedFormsByUserId");
    if (response.status === "success") {
      if (response.data) {
        setNumOfForms(response.data);
      }
    }
  };

  useEffect(() => {
    if (userData && userData.UserId) {
      getNumOfEmbedForms();
    }
  }, [userData]);

  return (
    <div className="forms-marketing-container">
      <MainBanner userData={userData} numOfForms={numOfForms} />
      <PageExampleSection />
      <CustomFormSection />
      <InboxSection />
      <FormFeaturesSection />
      <EmbedQuestions />
    </div>
  );
};

export default FormsMarketingPage;
